__turbopack_context__.v({
  "browseAll": "VgFN7q_browseAll",
  "root": "VgFN7q_root",
  "text": "VgFN7q_text",
});
